// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Admin › Sub-admins list and its add/edit dialogs. */

.subadmins-page__person {
  display: inline-flex;
  align-items: center;
  gap: var(--ds-space-2);
  min-width: 0;
}

.subadmins-page__person .ant-avatar {
  flex-shrink: 0;
}

.subadmins-page__status.ant-select {
  min-width: 120px;
}
`, "",{"version":3,"sources":["webpack://./src/admin/components/subadmins/SubAdmin.css"],"names":[],"mappings":"AAAA,sDAAsD;;AAEtD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* Admin › Sub-admins list and its add/edit dialogs. */\n\n.subadmins-page__person {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n  min-width: 0;\n}\n\n.subadmins-page__person .ant-avatar {\n  flex-shrink: 0;\n}\n\n.subadmins-page__status.ant-select {\n  min-width: 120px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
